<template>
  <div class="container" @mousedown="click" v-bind:title="title">
    <div class="icon"><i class="fa fa-tv"></i></div>
    <div class="text">
      <p class="headline" v-html="headline"></p>
      <p class="subline" v-html="subline"></p>
    </div>
    <div class="arrow"><i class="fa fa-chevron-right"></i></div>
  </div>
</template>

<script>
import SearchObject from "../../SearchObject";

export default {
  name: "NeedleItemVideo",
  data() {
    return {
      searchObj: new SearchObject(),
    };
  },
  computed: {
    title(){
      return this.$attrs.item.Title || '';
    },
    headline () {
      return this.boldIt(this.$attrs.item.Title, this.$attrs.needle);
    },
    subline() {
      return `Sendungen in denen über "<b>${this.$attrs.needle}</b>" berichtet wird`;
    }

  },
  methods: {
    click() {
      this.$parent.$parent.$parent.$parent.$data.showOverlay = true;
      this.searchObj.openWindow(this.$attrs.item);
    }
  }
};
</script>

<style lang="scss">
</style>